import React from "react";

import { Select } from "antd";

const communStyle = (changed) => ({
  width: "100%",
  border: "0px",
  backgroundColor: "transparent",
  borderBottom: "1px solid #9B9B9B",
  height: "30px",
  color: changed ? "#2854A1" : "#9B9B9B"
});

const MultiSelect = ({ children, changed, style, ...props }) => {
  return (
    <Select
      mode="multiple"
      bordered={false}
      showArrow={true}
      allowClear={true}
      disabled={false}
      maxTagCount={1}
      style={{
        ...communStyle(changed),
        ...style
      }}
      {...props}
    >
      {children}
    </Select>
  );
};

const SingleSelect = ({ children, changed, disabled = false, style = {}, showSearch = true, ...props }) => {
  return (
    <Select
      bordered={false}
      showArrow={true}
      disabled={disabled}
      showSearch={showSearch}
      style={{
        ...communStyle(changed),
        ...style
      }}
      {...props}
    >
      {children}
    </Select>
  );
};

export { SingleSelect, MultiSelect };
